import { render, staticRenderFns } from "./ProductPage2.vue?vue&type=template&id=0227d92a"
import script from "./ProductPage2.vue?vue&type=script&lang=js"
export * from "./ProductPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports